// tslint:disable: object-literal-sort-keys
export const messages = {
  appUpdate: 'Dostępna nowa wersja aplikacji. Zamknij aby przeładować.',
  registerSuccessful: 'Zarejestrowano i zalogowano pomyślnie.',
  /** Inline alert po rejestracji, gdy potrzebny jest drugi challenge Turnstile (login_stepup). */
  registerLoginStepUpHint:
    'Konto utworzone. Jeśli pojawi się weryfikacja bezpieczeństwa, potwierdź ją, aby dokończyć logowanie.',

  loginSuccessful: 'Zalogowano pomyślnie.',
  loginUnsuccessful: 'Logowanie nie powiodło się. Niepoprawny email / hasło.',

  /** Inline alert gdy widoczny Turnstile — od pierwszego pokazania widgetu (CTA dopasowany). */
  turnstileStepUpHintLogin:
    'Weryfikacja bezpieczeństwa. Jeśli zostaniesz o to poproszony, potwierdź poniżej. Następnie ponownie kliknij „Zaloguj”.',
  turnstileStepUpHintRegister:
    'Weryfikacja bezpieczeństwa. Jeśli zostaniesz o to poproszony, potwierdź poniżej. Następnie ponownie kliknij „Zarejestruj”.',
  turnstileStepUpHintApply:
    'Weryfikacja bezpieczeństwa. Jeśli zostaniesz o to poproszony, potwierdź poniżej. Następnie ponownie kliknij  „Aplikuj”.',

  logout: 'Wylogowano pomyślnie.',

  passwordReset: 'Wiadomość z linkiem do resetu hasła została wyslana na podany email.',
  passwordSet: 'Ustawiono nowe hasło oraz zalogowano pomyślnie.',

  applicationDeleteSuccess: (name: string, email: string) =>
    `Usunięto aplikację od: ${name} - ${email}.`,

  offerRenewSuccess: (offerTitle: string) => `Wznowiono '${offerTitle}'.`,
  offerRenewConfirmation: (offerTitle: string) => `Wznowić '${offerTitle}'?`,

  offerUnpublishSuccess: (offerTitle: string) => `Zdjęto '${offerTitle}'.`,
  offerUnpublishConfirmation: (offerTitle: string) => `Zdjąć '${offerTitle}'?`,

  offerDeleteConfirmation: (offerTitle: string) => `Na pewno usunąć '${offerTitle}'?`,
  offerDeleteSuccess: (offerTitle: string) => `Usunięto '${offerTitle}'.`,
  offerUpdateSuccess: (offerTitle: string) => `Zaktualizowano '${offerTitle}'.`,
  offerEditParseError: 'Nie można pobrać danych do edycji oferty.',
};
